import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/sagivbengiat/cloned_projects/react-elastic-carousel/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import Carousel, { consts } from 'react-elastic-carousel';
import Item from '../components/SimpleItem';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "itemposition"
    }}>{`itemPosition`}</h1>
    <h4 {...{
      "id": "sets-the-position-of-the-item-within-the-items-wrapper"
    }}>{`Sets the position of the item within the item's wrapper.`}</h4>
    <p><em parentName="p">{`You should import the `}<inlineCode parentName="em">{`consts`}</inlineCode>{` object to pass the desired `}<inlineCode parentName="em">{`itemPosition`}</inlineCode></em></p>
    <pre><code parentName="pre" {...{}}>{`import Carousel, { consts } from 'react-elastic-carousel';
`}</code></pre>
    <Playground __position={0} __code={'<Carousel itemPosition={consts.START} itemsToShow={2}>\n  <Item maxWidth=\"50%\">1</Item>\n  <Item maxWidth=\"50%\">3</Item>\n  <Item maxWidth=\"50%\">4</Item>\n  <Item maxWidth=\"50%\">5</Item>\n</Carousel>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Carousel,
      consts,
      Item,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Carousel itemPosition={consts.START} itemsToShow={2} mdxType="Carousel">
        <Item maxWidth="50%" mdxType="Item">1</Item>
        <Item maxWidth="50%" mdxType="Item">3</Item>
        <Item maxWidth="50%" mdxType="Item">4</Item>
        <Item maxWidth="50%" mdxType="Item">5</Item>
    </Carousel>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      